$(document).ready(function() {
    $("#pro-description-flip-1").click(function() {
        $("#pro-description-cpanel-1").slideToggle("slow", function() {
            // Toggle class to allow or restrict text wrapping
            $(".product-description").toggleClass("expanded");
        });
        $(".pro-description-descicon svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
    $("#cflip-1").click(function() {
        $("#cpanel-1").slideToggle("slow");
        $(".descicon svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
    $("#cflip-2").click(function() {
        $("#cpanel-2").slideToggle("slow");
        $(".descicon-2 svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
    $("#cflip-3").click(function() {
        $("#cpanel-3").slideToggle("slow");
        $(".descicon-3 svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
    $("#cflip-4").click(function() {
        $("#cpanel-4").slideToggle("slow");
        $(".descicon-4 svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
    $("#cflip-5").click(function() {
        $("#cpanel-5").slideToggle("slow");
        $(".descicon-5 svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
    $("#cflip-6").click(function() {
        $("#cpanel-6").slideToggle("slow");
        $(".descicon-6 svg").toggleClass("rotate-180"); // Toggle the anticlockwise rotation class
    });
});